<template>
  <div class="signin-header">
    <div class="header">
      <div class="back_icon" @click="$router.back()">
        <div class="iconfont icon-icon-back"></div>
        <div class="back_text">返回</div>
      </div>
    </div>
    <div class="headline">
      {{ courseInfo.name || "" }}
    </div>
    <div class="course_info">
      <div class="course_item">
        <div class="item_left iconfont icon-xxkc"></div>
        <div class="item_right">
          &nbsp;{{ courseInfo.classNames && courseInfo.classNames.join("，") }}
        </div>
        <div class="item_details" @click="DetailsDialog = true">详情</div>
      </div>
      <div class="course_item">
        <div class="item_left iconfont icon-jiaoshi"></div>
        <div class="item_right">&nbsp;{{ courseInfo.speakerText || "" }}</div>
      </div>
      <div class="course_item">
        <div class="item_left iconfont icon-address"></div>
        <div class="item_right">&nbsp;{{ courseInfo.place || "" }}</div>
      </div>
      <div class="course_item">
        <div class="item_left iconfont icon-rili"></div>
        <div class="item_right">&nbsp;{{dsf.date.format(courseInfo.beginDateTime, "mm月dd日 hh:ii")}}</div>
      </div>
    </div>
    <van-dialog
      v-model="DetailsDialog"
      width="85%"
      title="点击任意处关闭"
      close-on-click-overlay
      :show-confirm-button="false"
    >
      <div @click="DetailsDialog = false">
        <div class="closeIcon iconfont icon-icon_wrong" @click="DetailsDialog = false"></div>
        <div class="dialog_headline">班次情况</div>
        <div class="class_info">
          <div
            class="detail_item"
            v-for="(item, index) in courseInfo.classNames"
            :key="index"
          >
            {{ item }}
          </div>
        </div>
      </div>
    </van-dialog>
  </div>
</template>

<script>
// 签到情况
export default {
  data() {
    return {
      DetailsDialog: false, //班次详情
    };
  },
  props: {
    courseInfo: {
      type: Object,
      default: () => {},
    },
  },
  methods: {},
};
</script>